import { Button } from '@material-ui/core';
import { ActionHeader } from '.';
import en from '../../../lang/en-us';
const { dashboard } = en;

export default function SuccessScreen({
    heading = '',
    infospan2 = '',
    successMessage = '',
    info3 = '',
    list = [] as any,
    handleClick = () => {},
    backNavigation = () => {},
    showTrackStatusButton = true,
    ...props
}: any) {
    return (
        <>
            <ActionHeader header={heading} />
            <div className="curved-bg-content nct-success-screen" tabIndex={0}>
                <div className="curved-bg-content-inner">
                    <div className="curved-bg-content-inner-top" tabIndex={0}>
                        <img
                            className="change-email-img"
                            src="/images/portfolio-banner-character.png"
                            alt=""
                        />
                        <h3 className="subheading">{dashboard.Success.subHeading}</h3>
                        <p>
                            {infospan2 ? (
                                <>
                                    {dashboard.Success.subHeadingInfo1}
                                    <span>"{infospan2}"</span>.
                                </>
                            ) : (
                                successMessage
                            )}
                        </p>
                        <p>
                            For any queries, please reach out to{' '}
                            <a
                                href="mailto:support@mfcentral.com"
                                style={{ textDecoration: 'underline' }}
                            >
                                support@mfcentral.com
                            </a>{' '}
                            .
                        </p>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        {/* <ol>
                            {list.map((_childProps: any, index: any) => (
                                <Component {..._childProps} />
                            ))}
                        </ol> */}
                        {/* {showTrackStatusButton && (
                            <Button className="customBtn" onClick={handleClick}>
                                {dashboard.changeEmail.Success.buttonText}
                            </Button>
                        )} */}
                        {!!props.condition ? (
                            <Button className="customBtn" onClick={handleClick}>
                                {dashboard.changeEmail.Success.getStarted}
                            </Button>
                        ) : (
                            <>
                                {showTrackStatusButton && (
                                    <Button className="customBtn" onClick={handleClick}>
                                        {dashboard.changeEmail.Success.buttonText}
                                    </Button>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
}
